import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import EnterVoucherCode from '@/components/redeem/EnterVoucherCode.vue';
import RedeemInstructionsImage from '@/components/redeem/RedeemInstructionsImage.vue';
import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'EnterVoucherText',
  setup(__props) {

const { getters } = store;

const title = computed(() => getters.getTitle);
const text = computed(() => getters.getText);
const numberOfShops = computed(() => getters.getNumberOfShops);
const category = computed(() => getters.getCategory);
const showHowToRedeem = computed(() => getters.getShowHowToRedeem);
const configId = computed(() => getters.getConfigId);

return { __sfc: true,getters, title, text, numberOfShops, category, showHowToRedeem, configId, EnterVoucherCode, RedeemInstructionsImage }
}

})